<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Confirmation de l'annulation">
    <template v-slot:modalBody>
      <span>
        Etes-vous sûr de vouloir annuler la signature ? Cette action est
        irréversible.
      </span>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        v-if="props.on_close"
        variant="secondary"
        v-bind:on_click="props.on_close">
        Annuler
      </refonte-button>
      <refonte-button
        v-if="props.on_submit"
        variant="primary"
        v-bind:on_click="props.on_submit">
        Confirmer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_submit: Function;
      title?: string;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
